import isEmpty from 'lodash/isEmpty';
// import { setAccountExistent } from './auth';
import { socialLogInUserAction } from '../actions/social';
import { IAllContextsProps } from '../constants/interfaces';

declare global {
    interface Window {
        AppleID: any;
        FB: any;
        gapi: any;
    }
}

/**
 * Function to trick the app and make set it in the state after a call to an external provider
 */
export const onSkipSocialLinks = (
    socialProvider: string,
    contexts: IAllContextsProps,
) => {
    const socialDataMock = contexts.configContext?.social?.socialDataMock;
    const socialMock: any = socialDataMock?.[socialProvider];

    if (!isEmpty(socialMock)) {
        if (socialMock.email) {
            contexts.userContext?.methods.lookup.setExistentAccount(
                socialMock.email,
            );
        }

        mockAppleAuthLib(socialMock);

        mockFacebookAuthLib(socialMock, socialProvider, contexts);

        mockGoogleAuthLib(socialMock, socialProvider, contexts);
    }
};

const mockAppleAuthLib = (socialMock: any) => {
    window.AppleID = {};
    window.AppleID.auth = {
        signIn: () => {
            const appleConfirmation = confirm('Continue with apple?');

            /* istanbul ignore next */
            if (appleConfirmation) {
                return Promise.resolve(socialMock);
            } else {
                /* istanbul ignore next */
                return Promise.reject({
                    status: 'popup_closed_by_user',
                });
            }
        },
    };
};

const mockFacebookAuthLib = (
    socialMock: any,
    socialProvider: string,
    contexts: IAllContextsProps,
) => {
    window.FB = {};
    window.FB.login = () => {
        const fbConfirmation = confirm('Continue with facebook?');

        /* istanbul ignore next */
        if (fbConfirmation) {
            socialLogInUserAction({
                data: socialMock,
                socialProvider,
                contexts,
            });
        } else {
            /* istanbul ignore next */
            return false;
        }
    };
    window.FB.getLoginStatus = () => {
        return true;
    };
};

const mockGoogleAuthLib = (
    socialMock: any,
    socialProvider: string,
    contexts: IAllContextsProps,
) => {
    const auth2 = {
        signIn: () => {
            const googleConfirmation = confirm('Continue with Google?');

            /* istanbul ignore next */
            if (googleConfirmation) {
                socialLogInUserAction({
                    data: socialMock,
                    socialProvider,
                    contexts,
                });
            }

            return Promise.resolve();
        },
        init: () => {
            return true;
        },
    };

    window.gapi = {
        load: (_: any, callback: any) => {
            /* istanbul ignore next */
            callback();
        },
        auth2: {
            getAuthInstance: () => auth2,
        },
    };
};
